// src/phone/index.ts
import { parsePhoneNumberFromString } from "libphonenumber-js/core";

// src/phone/libphonenumber-metadata.json
var libphonenumber_metadata_default = {
  version: 4,
  country_calling_codes: {
    "30": ["GR"],
    "31": ["NL"],
    "32": ["BE"],
    "33": ["FR"],
    "34": ["ES"],
    "36": ["HU"],
    "39": ["IT"],
    "40": ["RO"],
    "43": ["AT"],
    "44": ["GB"],
    "45": ["DK"],
    "46": ["SE"],
    "48": ["PL"],
    "49": ["DE"],
    "351": ["PT"],
    "352": ["LU"],
    "353": ["IE"],
    "356": ["MT"],
    "357": ["CY"],
    "358": ["FI"],
    "359": ["BG"],
    "370": ["LT"],
    "371": ["LV"],
    "372": ["EE"],
    "385": ["HR"],
    "386": ["SI"],
    "420": ["CZ"],
    "421": ["SK"]
  },
  countries: {
    AT: [
      "43",
      "00",
      "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
      [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      [
        ["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"],
        ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"],
        ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"],
        ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"],
        ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"],
        ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"],
        ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        [
          "1(?:11\\d|[2-9]\\d{3,11})|(?:316|463|(?:51|66|73)2)\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-8]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"
        ],
        ["6(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d{4,10}", [7, 8, 9, 10, 11, 12, 13]],
        ["800\\d{6,10}", [9, 10, 11, 12, 13]],
        ["9(?:0[01]|3[019])\\d{6,10}", [9, 10, 11, 12, 13]],
        0,
        0,
        0,
        0,
        ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]],
        ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]
      ]
    ],
    BE: [
      "32",
      "00",
      "4\\d{8}|[1-9]\\d{7}",
      [8, 9],
      [
        ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"],
        ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"],
        ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"],
        ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        ["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]],
        ["4[5-9]\\d{7}", [9]],
        ["800[1-9]\\d{4}", [8]],
        [
          "(?:70(?:2[0-57]|3[0457]|44|69|7[0579])|90(?:0[0-35-8]|1[36]|2[0-3568]|3[0135689]|4[2-68]|5[1-68]|6[0-378]|7[23568]|9[34679]))\\d{4}",
          [8]
        ],
        0,
        0,
        ["78(?:0[57]|1[0458]|2[25]|3[15-8]|48|[56]0|7[078])\\d{4}", [8]],
        0,
        0,
        ["7879\\d{4}", [8]]
      ]
    ],
    BG: [
      "359",
      "00",
      "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
      [6, 7, 8, 9],
      [
        ["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"],
        ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"],
        ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"],
        ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"],
        ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"],
        ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"],
        ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"],
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        ["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]],
        ["43[07-9]\\d{5}|(?:48|8[7-9]\\d|9(?:8\\d|9[69]))\\d{6}", [8, 9]],
        ["800\\d{5}", [8]],
        ["90\\d{6}", [8]],
        0,
        0,
        0,
        0,
        0,
        ["700\\d{5}", [8]]
      ]
    ],
    CY: [
      "357",
      "00",
      "(?:[279]\\d|[58]0)\\d{6}",
      [8],
      [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]],
      0,
      0,
      0,
      0,
      0,
      0,
      [
        ["2[2-6]\\d{6}"],
        ["9[4-79]\\d{6}"],
        ["800\\d{5}"],
        ["90[09]\\d{5}"],
        ["700\\d{5}"],
        0,
        ["(?:50|77)\\d{6}"],
        0,
        0,
        ["80[1-9]\\d{5}"]
      ]
    ],
    CZ: [
      "420",
      "00",
      "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
      [9],
      [
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]],
        ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]],
        ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]
      ],
      0,
      0,
      0,
      0,
      0,
      0,
      [
        ["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}"],
        ["(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}"],
        ["800\\d{6}"],
        ["9(?:0[05689]|76)\\d{6}"],
        ["70[01]\\d{6}"],
        0,
        ["9(?:5\\d|7[2-4])\\d{6}"],
        0,
        ["9[17]0\\d{6}"],
        ["8[134]\\d{7}"]
      ]
    ],
    DE: [
      "49",
      "00",
      "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:[12]\\d|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|31|[46][1-8])\\d{1,9}",
      [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
      [
        ["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"],
        [
          "(\\d{3})(\\d{3,12})",
          "$1 $2",
          [
            "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
            "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
          ],
          "0$1"
        ],
        [
          "(\\d{4})(\\d{2,11})",
          "$1 $2",
          [
            "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
            "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
          ],
          "0$1"
        ],
        ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"],
        ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"],
        ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"],
        ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"],
        ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"],
        ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"],
        ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"],
        ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"],
        ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"],
        ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"],
        ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"],
        ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"],
        ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"],
        ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"],
        ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        [
          "32\\d{9,11}|49[3-6]\\d{10}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}",
          [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]
        ],
        ["15[0-25-9]\\d{8}|1(?:6[023]|7\\d)\\d{7,8}", [10, 11]],
        ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]],
        ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]],
        ["700\\d{8}", [11]],
        0,
        ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]],
        ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]],
        0,
        ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]
      ]
    ],
    DK: [
      "45",
      "00",
      "[2-9]\\d{7}",
      [8],
      [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]],
      0,
      0,
      0,
      0,
      0,
      0,
      [["(?:[2-7]\\d|8[126-9]|9[1-46-9])\\d{6}"], [""], ["80\\d{6}"], ["90\\d{6}"]]
    ],
    EE: [
      "372",
      "00",
      "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
      [7, 8, 10],
      [
        [
          "(\\d{3})(\\d{4})",
          "$1 $2",
          [
            "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
            "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
          ]
        ],
        ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]],
        ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]],
        ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]
      ],
      0,
      0,
      0,
      0,
      0,
      0,
      [
        ["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]],
        [
          "5(?:[0-35-9]\\d{6}|4(?:[0-57-9]\\d{5}|6(?:[0-24-9]\\d{4}|3(?:[0-35-9]\\d{3}|4000))))|8(?:1(?:0(?:000|[3-9]\\d\\d)|(?:1(?:0[236]|1\\d)|(?:23|[3-79]\\d)\\d)\\d)|2(?:0(?:000|(?:19|[24-7]\\d)\\d)|(?:(?:[124-6]\\d|3[5-9]|8[2-4])\\d|7(?:[679]\\d|8[13-9]))\\d)|[349]\\d{4})\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}",
          [7, 8]
        ],
        ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"],
        ["(?:40\\d\\d|900)\\d{4}", [7, 8]],
        ["70[0-2]\\d{5}", [8]]
      ]
    ],
    ES: [
      "34",
      "00",
      "[5-9]\\d{8}",
      [9],
      [
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]],
        ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]
      ],
      0,
      0,
      0,
      0,
      0,
      0,
      [
        [
          "96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"
        ],
        ["(?:590[16]00\\d|9(?:6906(?:09|10)|7390\\d\\d))\\d\\d|(?:6\\d|7[1-48])\\d{7}"],
        ["[89]00\\d{6}"],
        ["80[367]\\d{6}"],
        ["70\\d{7}"],
        0,
        ["51\\d{7}"],
        0,
        0,
        ["90[12]\\d{6}"]
      ]
    ],
    FI: [
      "358",
      "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
      "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
      [5, 6, 7, 8, 9, 10, 11, 12],
      [
        ["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"],
        ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"],
        ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"],
        ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      "1[03-79]|[2-9]",
      [
        ["(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}", [5, 6, 7, 8, 9]],
        ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]],
        ["800\\d{4,6}", [7, 8, 9]],
        ["[67]00\\d{5,6}", [8, 9]],
        0,
        0,
        [
          "20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"
        ]
      ],
      "00"
    ],
    FR: [
      "33",
      "00",
      "[1-9]\\d{8}",
      [9],
      [
        ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"],
        ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        ["(?:[1-35]\\d|4[1-9])\\d{7}"],
        ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7(?:00|[3-9]\\d))\\d{6}"],
        ["80[0-5]\\d{6}"],
        ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"],
        0,
        0,
        ["80[6-9]\\d{6}"],
        0,
        ["9\\d{8}"],
        ["8(?:1[01]|2[0156]|84)\\d{6}"]
      ]
    ],
    GB: [
      "44",
      "00",
      "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
      [7, 9, 10],
      [
        ["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"],
        ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"],
        ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"],
        [
          "(\\d{5})(\\d{4,5})",
          "$1 $2",
          [
            "1(?:38|5[23]|69|76|94)",
            "1(?:(?:38|69)7|5(?:24|39)|768|946)",
            "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
          ],
          "0$1"
        ],
        ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"],
        ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"],
        ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"],
        ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        [
          "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[023])|4(?:[0-5]\\d\\d|69[7-9]|70[059])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[259]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[278])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
          [9, 10]
        ],
        [
          "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
          [10]
        ],
        ["80[08]\\d{7}|800\\d{6}|8001111"],
        ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]],
        ["70\\d{8}", [10]],
        0,
        ["(?:3[0347]|55)\\d{8}", [10]],
        ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}", [10]],
        ["56\\d{8}", [10]]
      ],
      0,
      " x"
    ],
    GR: [
      "30",
      "00",
      "5005000\\d{3}|8\\d{9,10}|(?:[269]\\d|70)\\d{8}",
      [10, 11],
      [
        ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]],
        ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],
        ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]],
        ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["8"]]
      ],
      0,
      0,
      0,
      0,
      0,
      0,
      [
        [
          "2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}",
          [10]
        ],
        ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]],
        ["800\\d{7,8}"],
        ["90[19]\\d{7}", [10]],
        ["70\\d{8}", [10]],
        0,
        ["5005000\\d{3}", [10]],
        0,
        0,
        ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]
      ]
    ],
    HR: [
      "385",
      "00",
      "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
      [6, 7, 8, 9],
      [
        ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"],
        ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"],
        ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"],
        ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"],
        ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"],
        ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"],
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        ["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]],
        ["9(?:751\\d{5}|8\\d{6,7})|9(?:0[1-9]|[1259]\\d|7[0679])\\d{6}", [8, 9]],
        ["80[01]\\d{4,6}", [7, 8, 9]],
        ["6[01459]\\d{6}|6[01]\\d{4,5}", [6, 7, 8]],
        ["7[45]\\d{6}", [8]],
        0,
        ["62\\d{6,7}|72\\d{6}", [8, 9]]
      ]
    ],
    HU: [
      "36",
      "00",
      "[235-7]\\d{8}|[1-9]\\d{7}",
      [8, 9],
      [
        ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"],
        ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"],
        ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]
      ],
      "06",
      0,
      0,
      0,
      0,
      0,
      [
        ["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]],
        ["(?:[257]0|3[01])\\d{7}", [9]],
        ["(?:[48]0\\d|6802)\\d{5}"],
        ["9[01]\\d{6}", [8]],
        0,
        0,
        ["38\\d{7}", [9]],
        0,
        ["21\\d{7}", [9]]
      ]
    ],
    IE: [
      "353",
      "00",
      "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
      [7, 8, 9, 10],
      [
        ["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"],
        ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"],
        ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"],
        ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"],
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"],
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"],
        ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"],
        ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]],
        ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"],
        ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        [
          "(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"
        ],
        ["8(?:22|[35-9]\\d)\\d{6}", [9]],
        ["1800\\d{6}", [10]],
        ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]],
        ["700\\d{6}", [9]],
        0,
        ["818\\d{6}", [9]],
        0,
        ["76\\d{7}", [9]],
        ["18[59]0\\d{6}", [10]]
      ]
    ],
    IT: [
      "39",
      "00",
      "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
      [6, 7, 8, 9, 10, 11],
      [
        ["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]],
        [
          "(\\d{3})(\\d{3,6})",
          "$1 $2",
          ["0[13-57-9][0159]|8(?:03|4[17]|9[245])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]
        ],
        ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]],
        ["(\\d{4})(\\d{4})", "$1 $2", ["894"]],
        ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]],
        ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1[4679]|[38]"]],
        ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]"]],
        ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]],
        ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]],
        ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]
      ],
      0,
      0,
      0,
      0,
      0,
      0,
      [
        [
          "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
        ],
        ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]],
        ["80(?:0\\d{3}|3)\\d{3}", [6, 9]],
        [
          "(?:0878\\d\\d|89(?:2|4[5-9]\\d))\\d{3}|89[45][0-4]\\d\\d|(?:1(?:44|6[346])|89(?:5[5-9]|9))\\d{6}",
          [6, 8, 9, 10]
        ],
        ["1(?:78\\d|99)\\d{6}", [9, 10]],
        0,
        0,
        0,
        ["55\\d{8}", [10]],
        ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]
      ]
    ],
    LT: [
      "370",
      "00",
      "(?:[3469]\\d|52|[78]0)\\d{6}",
      [8],
      [
        ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1],
        ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1],
        ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1],
        ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]
      ],
      "8",
      0,
      "[08]",
      0,
      0,
      0,
      [
        ["(?:3[1478]|4[124-6]|52)\\d{6}"],
        ["6\\d{7}"],
        ["80[02]\\d{5}"],
        ["9(?:0[0239]|10)\\d{5}"],
        ["70[05]\\d{5}"],
        0,
        ["70[67]\\d{5}"],
        0,
        ["[89]01\\d{5}"],
        ["808\\d{5}"]
      ]
    ],
    LU: [
      "352",
      "00",
      "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
      [4, 5, 6, 7, 8, 9, 10, 11],
      [
        ["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],
        ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],
        ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]],
        ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]],
        ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]],
        ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]],
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]],
        ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]],
        ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]
      ],
      0,
      0,
      "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)",
      0,
      0,
      0,
      [
        ["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"],
        ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]],
        ["800\\d{5}", [8]],
        ["90[015]\\d{5}", [8]],
        0,
        0,
        0,
        0,
        ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]],
        ["801\\d{5}", [8]]
      ]
    ],
    LV: [
      "371",
      "00",
      "(?:[268]\\d|90)\\d{6}",
      [8],
      [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]],
      0,
      0,
      0,
      0,
      0,
      0,
      [["6\\d{7}"], ["2\\d{7}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]
    ],
    MT: [
      "356",
      "00",
      "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
      [8],
      [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]],
      0,
      0,
      0,
      0,
      0,
      0,
      [
        ["2(?:0(?:[19]\\d|3[1-4]|6[059])|[1-357]\\d\\d)\\d{4}"],
        ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"],
        ["800[3467]\\d{4}"],
        ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"],
        0,
        0,
        ["501\\d{5}"],
        ["7117\\d{4}"],
        ["3550\\d{4}"]
      ]
    ],
    NL: [
      "31",
      "00",
      "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}",
      [5, 6, 7, 8, 9, 10],
      [
        ["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"],
        ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"],
        ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"],
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"],
        ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-57-9]"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        [
          "(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}",
          [9]
        ],
        ["6[1-58]\\d{7}", [9]],
        ["800\\d{4,7}", [7, 8, 9, 10]],
        ["90[069]\\d{4,7}", [7, 8, 9, 10]],
        0,
        0,
        [
          "140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d",
          [5, 6, 9]
        ],
        ["66\\d{7}", [9]],
        ["(?:85|91)\\d{7}", [9]]
      ]
    ],
    PL: [
      "48",
      "00",
      "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?",
      [6, 7, 8, 9, 10],
      [
        ["(\\d{5})", "$1", ["19"]],
        ["(\\d{3})(\\d{3})", "$1 $2", ["11|64"]],
        [
          "(\\d{2})(\\d{2})(\\d{3})",
          "$1 $2 $3",
          [
            "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
            "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
          ]
        ],
        ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]],
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],
        ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]],
        ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]
      ],
      0,
      0,
      0,
      0,
      0,
      0,
      [
        [
          "47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))",
          [7, 9]
        ],
        ["211(?:1\\d|3[1-5])\\d{4}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]],
        ["800\\d{6,7}", [9, 10]],
        ["70[01346-8]\\d{6}", [9]],
        0,
        0,
        ["804\\d{6}", [9]],
        ["64\\d{4,7}", [6, 7, 8, 9]],
        ["39\\d{7}", [9]],
        ["801\\d{6}", [9]]
      ]
    ],
    PT: [
      "351",
      "00",
      "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
      [9],
      [
        ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]],
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]
      ],
      0,
      0,
      0,
      0,
      0,
      0,
      [
        ["2(?:[12]\\d|[35][1-689]|4[1-59]|6[1-35689]|7[1-9]|8[1-69]|9[1256])\\d{6}"],
        ["6[0356]92(?:30|9\\d)\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"],
        ["80[02]\\d{6}"],
        ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"],
        ["884[0-4689]\\d{5}"],
        0,
        ["70(?:7\\d|8[17])\\d{5}"],
        0,
        ["30\\d{7}"],
        ["80(?:8\\d|9[1579])\\d{5}"]
      ]
    ],
    RO: [
      "40",
      "00",
      "(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",
      [6, 9],
      [
        ["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"],
        ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"],
        ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"],
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        ["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"],
        ["7[01]20\\d{5}|7(?:0[013-9]|1[01]|[2-7]\\d|8[03-8]|9[019])\\d{6}", [9]],
        ["800\\d{6}", [9]],
        ["90[0136]\\d{6}", [9]],
        0,
        0,
        ["(?:37\\d|80[578])\\d{6}", [9]],
        0,
        0,
        ["801\\d{6}", [9]]
      ],
      0,
      " int "
    ],
    SE: [
      "46",
      "00",
      "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
      [6, 7, 8, 9, 10],
      [
        ["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"],
        ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44)"], "0$1", 0, "$1 $2"],
        ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"],
        ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"],
        [
          "(\\d{3})(\\d{2,3})(\\d{2})",
          "$1-$2 $3",
          [
            "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
          ],
          "0$1",
          0,
          "$1 $2 $3"
        ],
        ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"],
        [
          "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
          "$1-$2 $3 $4",
          ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],
          "0$1",
          0,
          "$1 $2 $3 $4"
        ],
        ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"],
        ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"],
        [
          "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
          "$1-$2 $3 $4",
          ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],
          "0$1",
          0,
          "$1 $2 $3 $4"
        ],
        ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"],
        ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        [
          "(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}",
          [7, 8, 9]
        ],
        ["7[02369]\\d{7}", [9]],
        ["20\\d{4,7}", [6, 7, 8, 9]],
        ["649\\d{6}|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]],
        ["75[1-8]\\d{6}", [9]],
        0,
        ["10[1-8]\\d{6}", [9]],
        ["74[02-9]\\d{6}", [9]],
        0,
        ["77[0-7]\\d{6}", [9]]
      ]
    ],
    SI: [
      "386",
      "00|10(?:22|66|88|99)",
      "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
      [5, 6, 7, 8],
      [
        ["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"],
        ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"],
        ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"],
        ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        ["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]],
        ["65(?:1\\d|55|[67]0)\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]],
        ["80\\d{4,6}", [6, 7, 8]],
        ["89[1-3]\\d{2,5}|90\\d{4,6}"],
        0,
        0,
        0,
        0,
        ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-489])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]
      ],
      "00"
    ],
    SK: [
      "421",
      "00",
      "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
      [6, 7, 9],
      [
        ["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"],
        ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"],
        ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"],
        ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"],
        ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]
      ],
      "0",
      0,
      0,
      0,
      0,
      0,
      [
        [
          "(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"
        ],
        ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]],
        ["800\\d{6}", [9]],
        ["9(?:00|[78]\\d)\\d{6}", [9]],
        0,
        0,
        ["96\\d{7}", [9]],
        ["9090\\d{3}", [7]],
        ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]],
        ["8[5-9]\\d{7}", [9]]
      ]
    ]
  },
  nonGeographic: {}
};

// src/phone/metadata.ts
var metadata_default = {
  /* eslint-disable-next-line camelcase */
  country_calling_codes: libphonenumber_metadata_default.country_calling_codes,
  countries: libphonenumber_metadata_default.countries,
  version: libphonenumber_metadata_default.version,
  nonGeographic: libphonenumber_metadata_default.nonGeographic
};

// src/constants/NumberTypes.ts
var NumberTypes_default = {
  MOBILE: "MOBILE",
  PREMIUM_RATE: "PREMIUM_RATE"
};

// src/phone/index.ts
var phone_default = (input, countryCode) => {
  const parsedPhoneNumber = parsePhoneNumberFromString(input, countryCode, metadata_default);
  if (!parsedPhoneNumber) {
    return {
      isCorrectCountry: false,
      isMobile: false,
      isPaidNumber: false,
      isValid: false
    };
  }
  return {
    parsedPhoneNumber,
    isCorrectCountry: parsedPhoneNumber.country === countryCode,
    isMobile: parsedPhoneNumber.getType() === NumberTypes_default.MOBILE,
    isPaidNumber: parsedPhoneNumber.getType() === NumberTypes_default.PREMIUM_RATE,
    isValid: parsedPhoneNumber.isValid()
  };
};

// src/cocNumber/validationByCountryCode.ts
var validationByCountryCode_default = {
  NL: {
    pattern: /^[0-9]{8}$/,
    maxLength: 8
  },
  BE: {
    pattern: /^[0-9]{10}$/,
    maxLength: 10
  }
};

// src/cocNumber/isValid.ts
var isValid_default = (cocNumber, validation) => {
  if (!validation) {
    return false;
  }
  return validation.pattern.test(cocNumber);
};

// src/cocNumber/index.ts
var cocNumber_default = (countryCode) => {
  const validation = validationByCountryCode_default[countryCode];
  return {
    isValid: (cocNumber) => isValid_default(cocNumber, validation),
    maxLength: validation && validation.maxLength
  };
};

// src/licensePlate/validationByCountryCode.ts
var NL_LICENSE_PLATE_REGEXP = new RegExp(
  "^[a-zA-Z0-9]{0,6}$|^[a-zA-Z0-9]{1}-[a-zA-Z0-9]{0,3}$|^[a-zA-Z0-9]{1}-[a-zA-Z0-9]{3}-[a-zA-Z0-9]{0,2}$|^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{0,2}$|^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{2}-[a-zA-Z0-9]{0,2}$|^[a-zA-Z0-9]{2}-[a-zA-Z0-9]{3}$|[a-zA-Z0-9]{2}-[a-zA-Z0-9]{3}-[a-zA-Z0-9]{0,1}$"
  // XX-XXX-X
);
var validationByCountryCode_default2 = {
  NL: {
    pattern: NL_LICENSE_PLATE_REGEXP
  }
};

// src/licensePlate/isValid.ts
var MAX_LICENSE_PLATE_LENGTH = 15;
var isValid_default2 = (licensePlate, validation) => {
  if (!validation || !licensePlate || licensePlate.length > MAX_LICENSE_PLATE_LENGTH) {
    return false;
  }
  return validation.pattern.test(licensePlate);
};

// src/licensePlate/index.ts
var licensePlate_default = (countryCode) => {
  const validation = validationByCountryCode_default2[countryCode];
  return {
    isValid: (licensePlate) => isValid_default2(licensePlate, validation)
  };
};

// src/index.ts
var src_default = {
  phone: phone_default,
  cocNumber: cocNumber_default,
  licensePlate: licensePlate_default
};
export {
  src_default as default
};
//# sourceMappingURL=index.mjs.map